module.exports = __webpack_public_path__ + "static/media/ab6.969baf27.png";